<template>
  <ModalTemplate
    transitionName="bounce"
    :isModalOpen="showModal.isForgotAccount"
    errorTitle="Forgot Account"
    :isErrorMeteIcon="true"
  >
    <template v-slot:contentDescription>
      계정 정보를 분실하신 경우<br />크리에이티브 공모전 운영사무국으로<br />연락 바랍니다.
    </template>
    <template v-slot:contact>
      <div class="contact">
        <p>
          <span>
            Email :
          </span>jehee@contec.kr
        </p>
        <p>
          <span>
            Phone :
          </span>042-863-4532
        </p>
      </div>
    </template>
  </ModalTemplate>
</template>

<script lang="ts" setup>
import ModalTemplate from '@/components/common/modal/ModalTemplate.vue';
import useCommonStore from '@/store/storeCommon';

const { showModal } = useCommonStore();
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.contact {
  margin: 7.7px auto 8.4px;
  border-top: 0.3px solid $color-green-yellow;
  padding-top: 6px;
  font-size: 12px;
  text-align: center;

  p {
    font-family: "Pretendard Light 300", sans-serif;

    span {
      font-family: "Pretendard SemiBold 600", sans-serif;
      color: $color-debra;
    }
  }
}
</style>